// Source
import * as HelperSrc from "../HelperSrc";

export default class StoreSetting<T> {
    storageSet = (value: T): void => {
        HelperSrc.writeStorage<T>("setting", value);

        HelperSrc.storageDispatchEvent("setting");
    };

    storageGet = (): T | undefined => {
        return HelperSrc.readStorage<T>("setting");
    };

    storageRemove = (): void => {
        HelperSrc.removeStorage("setting");
    };
}
